/*****************************************************************
 ** Copyright (c) 帕加马
 ** 创建人:      ly
 ** 创建日期:    2020/10/10
 ** 修改人:
 ** 修改日期:
 ** 描 述: 全局只读配置
 **-----------------------------------------------------------------
 ******************************************************************/

import axios from './axios';

//是否深度拷贝
const util = {
  clone(obj, deep) {
    return deep ? JSON.parse(JSON.stringify(obj)) : Object.assign({}, obj);
  },
};

var mixed = {
  http: axios,
  post: axios.post,
  get(url, pars, config) {
    if (pars) {
      pars.f_rnd = +new Date(); // 防止火狐缓存GET请求
      url += url.indexOf('?') > -1 ? '&' : '?';
      url += Object.keys(pars)
        .map((key) => key + '=' + pars[key])
        .join('&');
    }
    return axios.get(url, config);
  },
};

var $x = {};
Object.assign($x, mixed);

export default $x;
